import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class SignUpAsClientRequest {
  @jsonMember(String)
  public username!: string;

  @jsonMember(String)
  public password!: string;

  @jsonMember(String)
  public email!: string;

  @jsonMember(String)
  public firstName!: string;

  @jsonMember(String)
  public lastName!: string;

  @jsonMember(Boolean)
  public newsletter!: boolean;

  public constructor(
    username: string,
    password: string,
    email: string,
    firstName: string,
    lastName: string,
    newsletter: boolean,
  ) {
    this.username = username;
    this.password = password;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.newsletter = newsletter;
  }
}
